import { render } from "./Clearable.vue?vue&type=template&id=aaf38dbc"
import script from "./Clearable.vue?vue&type=script&lang=ts"
export * from "./Clearable.vue?vue&type=script&lang=ts"
script.render = render

export default script